import axios from "axios";
import { api_url } from "../config/config";

export const prestationService = {
  getPrestations: (catalog) => {
    return axios.get(`${api_url}prestations`, { params: { catalog } });
  },
  previewHitech: (quotationUuid, quotationDetailUuid) => {
    return axios.get(
      `${api_url}quotations/${quotationUuid}/details/${quotationDetailUuid}/prestations/preview-hitech`
    );
  },
};
